import React from 'react'
import PropTypes from 'prop-types'
import qs from 'qs'
import { useTranslation } from 'react-i18next'
import UtmUtils from '../../utils/utmUtils'
import { useDispatch, useSelector } from 'react-redux'
import { resetRedirectDialog } from '../../reducers/uiSlice'
import { useCheckout } from '../../hooks/useCheckout'
import { openWindow } from '../../utils/browserDetectUtils'
import { selectCurrentStore } from '../../reducers/storeSlice'
import { useViews } from 'state'
import { Dialog, DialogContent, DialogTitle, makeStyles, Typography } from '@material-ui/core'
import { Button } from '../Kit/Buttons'
import styles from '../../styles/dialog.styles'
import { usePIP } from '../../hooks/usePIP'
import { ButtonContainer } from './style'
import { useInHouseMetrics, usePostHogAnalytics } from '@gojiraf/analytics'
import { useUtm } from '@gojiraf/useutm'
const useStyles = makeStyles((theme) => styles(theme))

export const RedirectDialog = ({ paymentGateway, orderData, externalUrl, title }) => {
  const { t } = useTranslation()
  const { send: sendViews } = useViews()
  const dispatch = useDispatch()
  const store = useSelector(selectCurrentStore)
  const classes = useStyles()
  const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  const { utm_medium } = UtmUtils.getUtmObject(queryParams)
  const { isAppView } = useUtm(utm_medium)
  const { setEnabled } = usePIP()
  const { goToCheckout } = useCheckout(store)
  const { postHogTrackEvent } = usePostHogAnalytics()
  const { trackEvent: inHouseTrackEvent } = useInHouseMetrics()

  const handleGoBack = () => {
    dispatch(resetRedirectDialog())
    sendViews({ type: 'GO_BACK' })
  }

  const handleOnContinue = () => {
    postHogTrackEvent('redirect-click-confirm-button')
    postHogTrackEvent('checkout-started')
    inHouseTrackEvent('checkout-started')
    if (externalUrl !== null) {
      const anchor = document.createElement('a')
      anchor.href = externalUrl
      anchor.target = '_blank'
      anchor.click()
    } else {
      goToCheckout({
        orderData,
        checkoutWindow: openWindow(isAppView, paymentGateway.useTarget),
        selectedPaymentGateway: paymentGateway,
        onGoBack: handleGoBack,
      })
    }
    handleGoBack()
  }

  const handleOnCancel = () => {
    postHogTrackEvent('redirect-click-cancel-button')
    setEnabled(false)
    handleGoBack()
  }

  const getDialogTitle = () => {
    if (title) return title
    if (store.storeConfigurations.storeCustomization.checkoutDialogText) {
      return store.storeConfigurations.storeCustomization.checkoutDialogText
    }
    return t('dialogs.goToCheckout', { storeName: store.name })
  }

  return (
    <Dialog aria-labelledby="simple-dialog-title" maxWidth="xs" open>
      <DialogTitle>
        <Typography
          className={classes.message}
          component="p"
          variant="h6"
          color="primary"
          align="center"
        >
          {getDialogTitle()}
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.dialog__actions}>
        <ButtonContainer>
          <Button variant="contained" onClick={handleOnContinue}>
            {t('dialogs.acceptButton').toUpperCase()}
          </Button>
          <Button variant="text" onClick={handleOnCancel}>
            {t('dialogs.cancelButton').toUpperCase()}
          </Button>
        </ButtonContainer>
      </DialogContent>
    </Dialog>
  )
}

RedirectDialog.propTypes = {
  paymentGateway: PropTypes.object.isRequired,
  orderData: PropTypes.object.isRequired,
  externalUrl: PropTypes.string.isRequired,
  title: PropTypes.string,
}
